module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/**
 * 1. 
 */
(function(fox) {
	fox.registerMixin('Grid_Lazyload', {
		configure: function(options) {
			this.callParent('configure', arguments);
		},

		init: function() {
			this.pw = this.getParent();
			this.buf = {};
			this.pending = -1;
			this.hook('wrapPagerClick', '@parent #pager', 'onStartChangePage', 'changePage');
			this.hook('wrapPagerSet', '@parent #pager', 'onStopChangePage', 'preloadNextPage');
			this.hook('listRender', '@parent #list', 'onStartRendering', 'listRender');

			this.waitEvent(this.pw, 'updated', 'firstDlLoad');
		},

		firstDlLoad: function() {
			this.mainDl = this.pw.dl;
			this.cloneDl = fox.createDataLayer();
			this.handleEvent(this.cloneDl, 'loaded', 'cloneDlLoaded');
			this.preloadNextPage();
		},

		changePage: function(num) {
			if (num == 'next') {
				num = this.mainDl.getNextPageNumber();
			}

			if (this.buf[num]) {
				this.buf[num].clone(this.mainDl).dispatchEvent('loaded');
				this.preloadNextPage();
				return false;
			}

			if (this.pending == num) {
				this.waitEvent('@this', 'cloneDlLoaded', function() {
					this.changePage(num);
				});
				return false;
			}

			return true;
		},

		preloadNextPage: function() {
			this.mainDl.clone(this.cloneDl);
			var nextNum = this.cloneDl.getNextPageNumber();
			if (nextNum) {
				this.pending = nextNum;
				this.cloneDl.nextPage();
			}

			return false;
		},

		cloneDlLoaded: function() {
			this.buf[this.cloneDl._pager.cp] = this.cloneDl.clone(fox.createDl());
			this.pending = -1;
			this.dispatchEvent('cloneDlLoaded');
		},

		listRender: function() {
			this.rwom1('@parent #list').setOption('embed.location', 'lastChild');
		}
	});

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/mixin/grid/lazyload.js
// module id = 212
// module chunks = 0